import React from 'react';
import ReactGA from 'react-ga';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import LogRocket from 'logrocket';

import '../sass/app.scss';
import '../images/forum-vignette.jpg';

import { configureStore } from './redux';
import setupAxios from './util/axios';
import { routes } from './routes';

import Root from './components/Root';
import FindProfessional from './routes/FindProfessional';
import GAListener from './components/GAListener';

const store = configureStore(window.__INITIAL_STATE__);
window.globalDispatch = store.dispatch;
if (window.env.REACT_ROOT_DOMAIN) {
  document.domain = window.env.REACT_ROOT_DOMAIN;
}
setupAxios();
ReactGA.initialize(window.env.REACT_GOOGLE_ANALYTICS_KEY);

if (window.env.REACT_APP_ENV == 'production') {
  LogRocket.init('yjaejn/mysage');
}

render(
  <Provider store={store}>
    <Router>
      <GAListener>
        <Switch>
          <Route exact path={routes.findProfessional} component={FindProfessional} />
          <Route component={Root} />
        </Switch>
      </GAListener>
    </Router>
  </Provider>,
  document.getElementById('root'),
);

/// POLYFILLS
Number.isNaN =
  Number.isNaN ||
  function (value) {
    return value !== value;
  };
